import { StyleSheet } from "@react-pdf/renderer";

export const styles = StyleSheet.create({
  // Heading
  h1: {
    padding: 0,
    margin: 0,

    marginTop: 10.5, // 14px
    // marginBottom: 11.25, // 15px
    fontSize: 18, // 24px
    fontWeight: "bold",
    fontFamily: "Pretendard",
    paddingBottom: 5.25, // 7px
    borderBottom: 2.25, // 3px
    borderBottomColor: "#999",
    borderBottomStyle: "solid",
  },
  h2: {
    padding: 0,
    margin: 0,

    marginTop: 15, // 20px
    // marginBottom: 9.75, // 13px
    fontSize: 16.5, // 22px
    fontWeight: "bold",
    fontFamily: "Pretendard",
    paddingBottom: 5.25, // 7px
    borderBottom: 0.75, // 1px
    borderBottomColor: "#999",
    borderBottomStyle: "solid",
  },
  h3: {
    padding: 0,
    margin: 0,

    marginTop: 13.5, // 18px
    marginBottom: 1.5, // 2px
    fontSize: 15, // 20px
    fontWeight: "bold",
    fontFamily: "Pretendard",
  },
  h4: {
    padding: 0,
    margin: 0,

    marginTop: 7.5, // 10px
    marginBottom: 1.5, // 2px
    fontSize: 13.5, // 18px
    fontWeight: "bold",
    fontFamily: "Pretendard",
  },
  h5: {
    padding: 0,
    margin: 0,

    marginTop: 6.75, // 9px
    // marginBottom: -3, // -4px
    fontSize: 12, // 16px
    fontWeight: "bold",
    fontFamily: "Pretendard",
  },
  h6: {
    padding: 0,
    margin: 0,

    marginTop: 6.75, // 9px
    // marginBottom: -3, // -4px
    fontSize: 10.5, // 14px
    fontWeight: "bold",
    fontFamily: "Pretendard",
  },

  // Paragraph
  p: {
    padding: 0,
    margin: 0,

    fontSize: 10,
    fontFamily: "Pretendard",
    color: "#222",
    lineHeight: "160%",
  },

  // Bold
  strong: {
    fontWeight: "bold",
    fontFamily: "Pretendard",
  },

  del: {
    color: "#999",
  },

  hr: {
    borderTop: 0.75, // 1px
    borderTopColor: "#eee",
    borderTopStyle: "solid",
    marginTop: 12,
    marginBottom: 12,
  },

  // List
  ul: {
    marginTop: 2,
    marginBottom: 2,
    marginLeft: -10,
    fontFamily: "Pretendard",
  },
  ol: {
    marginTop: 2,
    marginBottom: 2,
    marginLeft: -10,
    fontFamily: "Pretendard",
  },
  li: {
    fontSize: 10,
    marginBottom: 2,
    fontFamily: "Pretendard",
    lineHeight: 2,
  },

  // Blockquote
  blockquote: {
    margin: 0,
    padding: 0,

    borderLeft: 3, // 4px
    borderLeftColor: "#e5e5e5",
    borderLeftStyle: "solid",

    paddingLeft: 12, // 16px
    paddingRight: 12, // 16px
    marginTop: 10.5, // 14px
    marginBottom: 10.5, // 14px

    fontFamily: "Pretendard",
    color: "#999",
  },

  // Table
  table: {
    marginTop: 9, // 12px
    maringBottom: 10.5, // 14px
    border: "1px solid #dadce0",
    tableLayout: "auto",
  },
  th: {
    paddingLeft: 9, // 12px
    paddingRight: 10.5, // 14px
    paddingTop: 4.5, // 6px
    paddingBottom: 3.75, // 5px

    border: "1px solid #dadce0",
    textAlign: "center",

    backgroundColor: "#555555",
    color: "#e9e9e9",
  },
  td: {
    paddingLeft: 9, // 12px
    paddingRight: 10.5, // 14px
    paddingTop: 3.75, // 5px
    paddingBottom: 3.75, // 5px

    border: "1px solid #dadce0",
    textAlign: "center",

    color: "#222222",
  },
  tr: {},
});
